import { zodResolver } from '@hookform/resolvers/zod'
import { AxiosResponse } from 'axios'
import { useForm } from 'react-hook-form'
import { useRemoteClientPost } from '../../configs/http-client'
import { RoutesPath } from '../../configs/routes-path'
import { Endpoints } from '../../remote/endpoints'
import { useLocalStorage } from '../../remote/local-storage'
import { ResponseLogin } from '../../remote/types/response-login'
import { useNavigateRoute, useToast } from '../hooks'
import { LoginForm, loginSchema } from '../validators/login-validator'
import { ErrorMessageInput } from './error-message-input'
import { Button } from './ui/button'
import { Input } from './ui/input'

export function LoginFormPage() {
  const { navigateTo } = useNavigateRoute()
  const { httpClientPost } = useRemoteClientPost()
  const { useSetLocalStorage, getUnitId, isProfileAdmin } = useLocalStorage()
  const { showToast } = useToast()

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<LoginForm>({
    resolver: zodResolver(loginSchema)
  })

  const submit = async (data: any) => {
    try {
      const response: AxiosResponse<ResponseLogin> = await httpClientPost(Endpoints.login, data)

      useSetLocalStorage(response.data.data)
      console.log(response.data.data)
      if (isProfileAdmin()) {
        navigateTo(RoutesPath.dashboard + `?unit=${getUnitId()}&navId=${1}`)
      } else {
        navigateTo(RoutesPath.reception + `?unit=${getUnitId()}&navId=${2}`)
      }

      //navigateTo(RoutesPath.dashboard + `?unit=${getUnitId()}&navId=${1}`)
    } catch (error: any) {
      console.log(error.status)
      if (error.status === 403) {
        showToast('Acesso não autorizado', 'error')
      } else {
        showToast('Erro no login', 'error')
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(submit)} className="max-w-96 w-full flex flex-col m-auto ">
      <h3 className="text-3xl text-[#262626]">Bem-vindo ao AceleraFit!</h3>
      <h5 className="mb-6 text-[#666] text-base">Continue abaixo para acessar sua conta</h5>
      <div className="flex flex-col gap-1.5">
        <label className="text-[#6B7280] text-sm">Email</label>
        <Input {...register('email')} placeholder="Email" />
        {errors?.email && <ErrorMessageInput message={errors.email.message} />}
      </div>
      <div className="flex flex-col gap-1.5 mt-6">
        <label className="text-[#6B7280] text-sm ">Senha</label>
        <Input {...register('senha')} placeholder="Senha" type="password" />
        {errors?.senha && <ErrorMessageInput message={errors.senha.message} />}
      </div>
      <div className="flex justify-end mt-1 ">
        <a className="underline text-sm text-[#262626] cursor-pointer" onClick={() => navigateTo(RoutesPath.forgotPassword)}>
          Esqueci minha senha
        </a>
      </div>
      <Button type="submit" className="bg-acelerafit-green-200 hover:bg-acelerafit-green-50 mt-7">
        Entrar
      </Button>
    </form>
  )
}
